<template>
<v-row>
  <v-col cols="12" sm="3">
      <h3>Files Details</h3>
  </v-col>
  <v-col cols="12" sm="3">
      <v-text-field
        v-model="addfiles.filename"
        label="File Name"
        type="text"
        :rules="[v => !!v || 'Item is required']"
        required
      ></v-text-field>
  </v-col>
  <v-col cols="12" sm="3">
      <v-file-input v-model="addfiles.file" show-size label="File input" :rules="[v => !!v || 'Item is required']"></v-file-input>
  </v-col>
  <v-col cols="12" sm="3">
     <v-btn color="success" class="mr-2" @click="addfilespost()">Submit</v-btn>
  </v-col>
  <v-col cols="12">
  <v-simple-table>
    <template v-slot:default>
          <thead>
              <tr>
              <th>File Name</th>
              <th>Download</th>
              <th>Action</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="file in files" :key="file.id">
                  <td>{{ file.filename }}</td>
                  <td><a href="">{{ file.url }}</a></td>
                  <td><v-icon small color="red darken-2" @click="removefiles(file.id)">fas fa-trash</v-icon></td>
              </tr>
          </tbody>
    </template>
  </v-simple-table>
  </v-col>
</v-row>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';
  export default {
    props : {
        projectid: Number,
        files : Array
    },
    data: () => ({
      addfiles: {
        filename: '',
        file: ''
      },
    }),
    computed: {
      ...mapGetters(["currentuser"]),
    },
    methods: {
        ...mapActions(['addprojectfiles','deletefiles']),
        addfilespost() {
          if(this.addfiles.file && this.addfiles.filename)
          {
            let formData = new FormData();
            formData.append('filename',this.addfiles.filename);
            formData.append("file", this.addfiles.file);
            formData.append('project_id',this.projectid);
            formData.append('user_id',this.currentuser.id);
            this.addprojectfiles({ formData : formData,projectid : this.projectid});
          }else{
            alert("Both field is required.");
          }
        },
        removefiles(fileid)
        {
          this.deletefiles({ fileid:fileid,projectid : this.projectid});
        }
    },
  }
</script>